import SimplePage from "@/components/layout/SimplePage";

export default function YouthEducation() {
  return (
    <SimplePage
      title="Hebrew School & Religious School (K-7) at Temple Israel of Brevard"
      eyebrow="Religious School"
      subtitle="Joyful, hands-on Hebrew school and religious school for children from kindergarten through grade seven, in Melbourne, FL."
      description="The Hebrew school and religious school at Temple Israel of Brevard - Sunday-morning classes for K-7 children in Melbourne, FL. Hebrew, holidays, ethics, b'nei mitzvah prep, and friendships."
      path="/education/youth"
      ctaLabel="Enroll your child"
    >
      <p>
        TIOB's Religious School meets Sunday mornings during the school year and
        nurtures each child's Jewish identity through Hebrew, holidays, Bible
        stories, ethics, music, and friendship. Small classes mean every child
        is seen and every voice is heard.
      </p>

      <h2>Curriculum at a Glance</h2>
      <ul>
        <li>
          <strong>Kindergarten - Grade 2.</strong> Building a Jewish home -
          holidays, Shabbat, the Hebrew alphabet, mitzvot through stories and song.
        </li>
        <li>
          <strong>Grades 3 - 4.</strong> Reading Hebrew, prayer fluency, Bible
          heroes, the Jewish calendar, beginning b'nei-mitzvah preparation skills.
        </li>
        <li>
          <strong>Grades 5 - 6.</strong> Jewish history, ethics in action,
          deeper liturgy study, mitzvah projects, and continuing Hebrew.
        </li>
        <li>
          <strong>Grade 7 - B'nei Mitzvah Year.</strong> One-on-one work with
          the rabbi to prepare each student for their bar or bat mitzvah,
          including Torah and Haftarah portions and a personal d'var Torah.
        </li>
      </ul>

      <h2>B'nei Mitzvah</h2>
      <p>
        Rabbi Fanwick works closely with each family from approximately one
        year before the ceremony, partnering with parents and students to make
        the experience meaningful, personal, and joyful. Conversion students
        and adult b'nei mitzvah candidates are also warmly welcome.
      </p>

      <h2>Tuition</h2>
      <p>
        <strong>Religious School is included FREE with your family's TIOB
        membership</strong> - there is no additional tuition for member
        families, from kindergarten through grade seven. For non-member
        families, or for questions about supplies, retreats, and B'nei Mitzvah
        preparation costs, please contact the office. Financial hardship
        should never be a barrier to Jewish education at TIOB, and scholarship
        assistance is available quietly and with dignity.
      </p>

      <h2>Family Events</h2>
      <p>
        Beyond the classroom, families gather for the annual Religious-School
        Picnic, holiday celebrations, Shabbat family services, and end-of-year
        BBQ - many of which appear in our{" "}
        <a href="/gallery">photo gallery</a>.
      </p>
    </SimplePage>
  );
}
